/**
 * Returns the symbol for the observable protocol.
 *
 * @remarks
 *
 * This symbol is used to identify objects that conform to the observable protocol,
 * allowing them to be used with RxJS and other libraries that support the observable pattern.
 */
function getSymbolForObservableInterop() {
    const $Symbol = globalThis.Symbol;
    const symbolForObservableInterop = $Symbol.observable ?? $Symbol.for("knyt.artisan.observable");
    if (!$Symbol.observable && !Object.isFrozen($Symbol)) {
        $Symbol.observable = symbolForObservableInterop;
    }
    return symbolForObservableInterop;
}
/**
 * @internal scope: workspace
 */
export const OBSERVABLE_SYMBOL = getSymbolForObservableInterop();
/**
 * @internal scope: workspace
 */
export const OBSERVABLE_PROPERTY_NAME = "@@observable";
